<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.dashboard') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
      </ol>
    </section>
    <section v-if="authMap.dashboard != 2" class="content">
      <div class="row">
        <div class="col-md-3 col-sm-6 col-xs-12" v-show="modules.controlPanelStatistics">
          <div class="info-box" @click="getFastReport($ml.get('dashboard.fastReportTitleTodayStartOfWorks'), 0)"
            style="cursor:pointer;" :title="$ml.get('dashboard.fastReportView')">
            <span class="info-box-icon bg-green">
              <div class="overlay" id="load" :hidden="!isLoadingData">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <i class="ion ion-ios-checkmark" style="margin-top:20px;"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">
                <span>{{ $ml.get('dashboard.startOfWorks') }}</span>
              </span>
              <span class="info-box-number" style="text-align:center; font-size:25px;">
                <span>{{ startWorkEmployees }}</span>
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
          <!-- /.info-box -->
        </div>
        <!-- /.col -->
        <div class="col-md-3 col-sm-6 col-xs-12" v-show="modules.controlPanelStatistics">
          <div class="info-box" @click="getFastReport($ml.get('dashboard.fastReportTitleTodayAbsentees'), 1)"
            style="cursor:pointer;" :title="$ml.get('dashboard.fastReportView')">
            <span class="info-box-icon bg-red">
              <div class="overlay" id="load" :hidden="!isLoadingData">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <i class="ion ion-ios-close" style="margin-top:20px;"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">
                <span>{{ $ml.get('dashboard.absentees') }}</span>
              </span>
              <span class="info-box-number" style="text-align:center; font-size:25px;">
                <span>{{ discontinuity }}</span>
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
          <!-- /.info-box -->
        </div>
        <!-- /.col -->
        <div class="clearfix visible-sm-block"></div>
        <div class="col-md-3 col-sm-6 col-xs-12" v-show="modules.controlPanelStatistics">
          <div class="info-box" @click="getFastReport($ml.get('dashboard.fastReportTitleTodayLateComers'), 11)"
            style="cursor:pointer;" :title="$ml.get('dashboard.fastReportView')">
            <span class="info-box-icon bg-yellow">
              <div class="overlay" id="load" :hidden="!isLoadingData">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <i class="ion ion-ios-alarm" style="margin-top:20px;"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">
                <span>{{ $ml.get('dashboard.lateComers') }}</span>
              </span>
              <span class="info-box-number" style="text-align:center; font-size:25px;">
                <span>{{ lateComers }}</span>
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
          <!-- /.info-box -->
        </div>
        <!-- /.col -->
        <div class="col-md-3 col-sm-6 col-xs-12" v-show="modules.controlPanelStatistics">
          <div class="info-box" @click="getFastReport($ml.get('dashboard.fastReportTitleTotalEmployees'), 2)"
            style="cursor:pointer;" :title="$ml.get('dashboard.fastReportView')">
            <span class="info-box-icon" style="background:#3C8DBC; color:#fff;">
              <div class="overlay" id="load" :hidden="!isLoadingData">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <i class="ion ion-ios-contact-outline" style="margin-top:20px;"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">
                <span>{{ $ml.get('dashboard.totalEmployee') }}</span>
              </span>
              <span class="info-box-number" style="text-align:center; font-size:25px;">
                <span>{{ totalEmployees }}</span>
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
          <!-- /.info-box -->
        </div>
        <!-- /.col -->
      </div>
      <div class="row">
        <div
          class="col-sm-6 col-md-4">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">
                <i class="fa fa-thumb-tack"></i>
                <span>{{ $ml.get('dashboard.deviceStatus') }}</span>
                <br />
                <span style="font-size:12px;" v-show="lastConnectionTime">({{ $ml.get('dashboard.lastUpdate') }} :
                  {{ lastConnectionTime | toDateFormatGet("gg.aa.yyyy ss:dd") }})</span>
              </h3>
            </div>
            <!-- /.box-header -->
            <div class="box-body">
              <div class="row">
                <div class="col-sm-6">
                  <div v-show="deviceList.length > 0" id="infoDevices"></div>
                  <i v-show="deviceList.length == 0 && !isLoading" class="fa fa-microchip"
                    style="font-size:60px;color:#00A0F0;margin-top:50px;text-align:center;height:150px;width:100%;"></i>
                </div>
                <div class="col-sm-6">
                  <!--CONNECTED-->
                  <div class="info-box bg-green" @click="openDeviceReport()"
                    style="cursor:pointer;min-height:60px;" :title="$ml.get('dashboard.fastReportView')">
                    <span class="info-box-icon" style="width:40px;height:65px;">
                      <i v-show="!isLoading" class="fa fa-microchip" style="font-size:20px;"></i>
                    </span>

                    <div class="info-box-content" style="margin-left:10px;text-align:center;">
                      <span class="info-box-text" style="font-size:12px;margin-left:10px;">Bağlı</span>
                      <span class="info-box-number">{{ connectedDevice }}</span>

                      <div class="progress">
                        <div v-show="connectedDevice != null" class="progress-bar"
                          :style="'width:' + this.connectedDevice * 100 / this.deviceList.length + '%'"></div>
                      </div>
                      <span class="progress-description"></span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                  <!--DISCONNECTED-->
                  <div class="info-box bg-red" @click="openDeviceReport()"
                    style="cursor:pointer;min-height:60px;" :title="$ml.get('dashboard.fastReportView')">
                    <span class="info-box-icon" style="width:40px;height:65px;">
                      <i v-show="!isLoading" class="fa fa-microchip" style="font-size:20px;"></i>
                    </span>
                    <div class="info-box-content" style="margin-left:10px;text-align:center;">
                      <span class="info-box-text" style="font-size:12px;margin-left:10px;">Bağlantı Sorunu</span>
                      <span class="info-box-number">{{ disconnectedDevice }}</span>

                      <div class="progress">
                        <div v-show="disconnectedDevice != null" class="progress-bar"
                          :style="'width:' + this.disconnectedDevice * 100 / this.deviceList.length + '%'"></div>
                      </div>
                      <span class="progress-description"></span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                  <!--OTHER DEVICE STATUS-->
                  <div class="info-box bg-yellow"
                    @click="openDeviceReport()"
                    style="cursor:pointer;min-height:60px;" :title="$ml.get('dashboard.fastReportView')">
                    <span class="info-box-icon" style="width:40px;height:65px;">
                      <i v-show="!isLoading" class="fa fa-microchip" style="font-size:20px;"></i>
                    </span>
                    <div class="info-box-content" style="margin-left:10px;text-align:center;">
                      <span class="info-box-text" style="font-size:12px;margin-left:10px;">Bilinmeyen</span>
                      <span class="info-box-number">{{ otherDeviceStatus }}</span>

                      <div class="progress">
                        <div v-show="otherDeviceStatus != null" class="progress-bar"
                          :style="'width:' + this.otherDeviceStatus * 100 / this.deviceList.length + '%'"></div>
                      </div>
                      <span class="progress-description"></span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
          <div class="info-box"
            v-show="modules.diningHall && authControl(authMap.yemekhane) && modules.controlPanelStatistics">
            <span class="info-box-icon bg-yellow">
              <div class="overlay" id="load" :hidden="!isLoadingFoodData">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <i class="ion ion-pizza" style="margin-top:20px;"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">
                <span>{{ $ml.get('realTimeMonitor.todayTotalFood') }}</span>
              </span>
              <span class="info-box-number" style="text-align:center; font-size:25px;">
                <span>{{ totalFoodCount }}</span>
              </span>
            </div>
            <!-- /.info-box-content -->
          </div>
          <!-- /.info-box -->
           <div class="info-box" v-show="modules.visitor && authControl(authMap.ziyaretciTakip)"
            @click="getFastReport($ml.get('dashboard.fastReportTitleInsideVisitors'), 6)"
            style="background:#3C8DBC; color:#fff;cursor:pointer;" :title="$ml.get('dashboard.fastReportView')">
            <span class="info-box-icon" style="font-size:30px;">
              <div class="overlay" id="load" :hidden="!isLoadingVisitor">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <i v-show="!isLoadingVisitor" class="fa fa-address-card"></i>
            </span>

            <div class="info-box-content">
              <span class="info-box-text">{{ $ml.get('dashboard.insideVisitors') }}</span>
              <span class="info-box-number">{{ insideVisitors }}</span>

              <div class="progress">
                <div v-show="insideVisitors != null" class="progress-bar"
                  :style="'width:' + this.insideVisitors * 100 / this.totalEmployees + '%'"></div>
              </div>
              <span class="progress-description"></span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <div
          class="col-sm-6 col-md-4">
          <div class="box box-primary">
            <div class="box-header">
              <h4 class="box-title">
                <i class="fa fa-users"></i> Kişi İstatistikleri
              </h4>
              <div class="pull-right box-tools"></div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-6">
                  <div v-show="totalEmployees > 0" id="infoEmployees"></div>
                  <div class="overlay" id="load" :hidden="!isLoadingData" style="font-size:30px;height:150px;">
                    <i class="fa fa-refresh fa-spin"></i>
                  </div>
                  <i v-show="totalEmployees == 0 && !isLoadingData" class="fa fa-users"
                    style="font-size:60px;color:#00A0F0;margin-top:50px;text-align:center;height:150px;width:100%;"></i>
                </div>
                <div class="col-sm-6">
                  <!--INSIDE EMPLOYEES-->
                  <div class="info-box bg-green" @click="getFastReport($ml.get('dashboard.fastReportTitleInsides'), 3)"
                    style="cursor:pointer;min-height:60px;" :title="$ml.get('dashboard.fastReportView')">
                    <span class="info-box-icon" style="width:40px;height:65px;">
                      <i v-show="isLoadingData" class="fa fa-refresh fa-spin" style="font-size:20px;"></i>
                      <i v-show="!isLoadingData" class="ion ion-ios-people" style="font-size:30px;"></i>
                    </span>

                    <div class="info-box-content" style="margin-left:10px;text-align:center;">
                      <span class="info-box-text" style="font-size:12px;margin-left:10px;">{{
                        $ml.get('dashboard.insides') }}</span>
                      <span class="info-box-number">{{ insides }}</span>

                      <div class="progress">
                        <div v-show="insides != null" class="progress-bar"
                          :style="'width:' + this.insides * 100 / this.totalEmployees + '%'"></div>
                      </div>
                      <span class="progress-description"></span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                  <!--OUTSIDE EMPLOYEES-->
                  <div class="info-box bg-red" @click="getFastReport($ml.get('dashboard.fastReportTitleOutsides'), 4)"
                    style="cursor:pointer;min-height:60px;" :title="$ml.get('dashboard.fastReportView')">
                    <span class="info-box-icon" style="width:40px;height:65px;">
                      <i v-show="isLoadingData" class="fa fa-refresh fa-spin" style="font-size:20px;"></i>
                      <i v-show="!isLoadingData" class="ion ion-ios-people-outline" style="font-size:30px;"></i>
                    </span>
                    <div class="info-box-content" style="margin-left:10px;text-align:center;">
                      <span class="info-box-text" style="font-size:12px;margin-left:10px;">{{
                        $ml.get('dashboard.outsides') }}</span>
                      <span class="info-box-number">{{ outsides }}</span>

                      <div class="progress">
                        <div v-show="outsides != null" class="progress-bar"
                          :style="'width:' + this.outsides * 100 / this.totalEmployees + '%'"></div>
                      </div>
                      <span class="progress-description"></span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                  <!--ALLOWENCED EMPLOYEES-->
                  <div v-show="modules.payroll" class="info-box bg-yellow"
                    @click="getFastReport($ml.get('dashboard.fastReportTitleTodayAllowence'), 5)"
                    style="cursor:pointer;min-height:60px;" :title="$ml.get('dashboard.fastReportView')">
                    <span class="info-box-icon" style="width:40px;height:65px;">
                      <i v-show="isLoadingData" class="fa fa-refresh fa-spin" style="font-size:20px;"></i>
                      <i v-show="!isLoadingData" class="ion ion-ios-paperplane-outline" style="font-size:30px;"></i>
                    </span>
                    <div class="info-box-content" style="margin-left:10px;text-align:center;">
                      <span class="info-box-text" style="font-size:12px;margin-left:10px;">{{
                        $ml.get('dashboard.allowenceEmployees') }}</span>
                      <span class="info-box-number">{{ allowencedEmployees }}</span>

                      <div class="progress">
                        <div v-show="allowencedEmployees != null" class="progress-bar"
                          :style="'width:' + this.allowencedEmployees * 100 / this.totalEmployees + '%'"></div>
                      </div>
                      <span class="progress-description"></span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!--DORMITORY-->
          <div class="box box-primary" v-show="modules.dormitory">
            <div class="box-header">
              <h4 class="box-title">
                <i class="fa fa-building"></i> Yurt İstatistikleri
              </h4>
              <div class="pull-right box-tools"></div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-6">
                  <div v-show="dormitoryTotalStudent > 0" id="infoStudents"></div>
                  <div class="overlay" id="load" :hidden="!isLoadingData" style="font-size:30px;height:150px;">
                    <i class="fa fa-refresh fa-spin"></i>
                  </div>
                  <i v-show="dormitoryTotalStudent == 0 && !isLoadingData" class="fa fa-graduation-cap"
                    style="font-size:60px;color:#00A0F0;margin-top:50px;text-align:center;height:150px;width:100%;"></i>
                </div>
                <div class="col-sm-6">
                  <!--TOTAL ACTIVE STUDENTS-->
                  <div class="info-box" v-show="modules.dormitory"
                    @click="getDormitoryFastReport($ml.get('dashboard.fastReportTitleActiveStudents'), 3)"
                    style="background:#3C8DBC; color:#fff;cursor:pointer;min-height:60px;"
                    :title="$ml.get('dashboard.fastReportView')">
                    <span class="info-box-icon" style="width:40px;height:65px;">
                      <div class="overlay" id="load" :hidden="!isLoadingDormitoryData" style="font-size:30px;">
                        <i class="fa fa-refresh fa-spin"></i>
                      </div>
                      <i v-show="!isLoadingDormitoryData" class="fa fa-graduation-cap"
                        style="font-size:20px;vertical-align:middle;margin-bottom:20px;"></i>
                    </span>

                    <div class="info-box-content" style="margin-left:10px;text-align:center;">
                      <span class="info-box-text" style="font-size:12px;margin-left:10px;">{{
                        $ml.get('dashboard.activeStudentsInDormitory') }}</span>
                      <span class="info-box-number">{{ dormitoryTotalStudent }}</span>

                      <div class="progress">
                        <div v-show="dormitoryTotalStudent != null" class="progress-bar"
                          :style="'width:' + this.dormitoryTotalStudent * 100 / this.totalEmployees + '%'"></div>
                      </div>
                      <span class="progress-description"></span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                  <!--INSIDE STUDENTS-->
                  <div class="info-box bg-green" v-show="modules.dormitory"
                    @click="getDormitoryFastReport($ml.get('dashboard.fastReportTitleInsideStudents'), 0)"
                    style="cursor:pointer;min-height:60px;" :title="$ml.get('dashboard.fastReportView')">
                    <span class="info-box-icon" style="width:40px;height:65px;">
                      <div class="overlay" id="load" :hidden="!isLoadingDormitoryData" style="font-size:30px;">
                        <i class="fa fa-refresh fa-spin"></i>
                      </div>
                      <i v-show="!isLoadingDormitoryData" class="fa fa-building"
                        style="font-size:20px;vertical-align:middle;margin-bottom:20px;"></i>
                    </span>

                    <div class="info-box-content" style="margin-left:10px;text-align:center;">
                      <span class="info-box-text" style="font-size:12px;margin-left:10px;">{{
                        $ml.get('dashboard.insideStudentsInDormitory') }}</span>
                      <span class="info-box-number">{{ dormitoryInsideStudent }}</span>

                      <div class="progress">
                        <div v-show="dormitoryInsideStudent != null" class="progress-bar"
                          :style="'width:' + this.dormitoryInsideStudent * 100 / this.dormitoryTotalStudent + '%'">
                        </div>
                      </div>
                      <span class="progress-description"></span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                  <!--OUTSIDE STUDENTS-->
                  <div class="info-box bg-red" v-show="modules.dormitory"
                    @click="getDormitoryFastReport($ml.get('dashboard.fastReportTitleOutsideStudents'), 1)"
                    style="cursor:pointer;min-height:60px;" :title="$ml.get('dashboard.fastReportView')">
                    <span class="info-box-icon" style="width:40px;height:65px;">
                      <div class="overlay" id="load" :hidden="!isLoadingDormitoryData" style="font-size:30px;">
                        <i class="fa fa-refresh fa-spin"></i>
                      </div>
                      <i v-show="!isLoadingDormitoryData" class="fa fa-sign-out"
                        style="font-size:20px;vertical-align:middle;margin-bottom:20px;"></i>
                    </span>

                    <div class="info-box-content" style="margin-left:10px;text-align:center;">
                      <span class="info-box-text" style="font-size:12px;margin-left:10px;">{{
                        $ml.get('dashboard.outsideStudentsInDormitory') }}</span>
                      <span class="info-box-number">{{ dormitoryOutsideStudent }}</span>

                      <div class="progress">
                        <div v-show="dormitoryOutsideStudent != null" class="progress-bar"
                          :style="'width:' + this.dormitoryOutsideStudent * 100 / this.dormitoryTotalStudent + '%'">
                        </div>
                      </div>
                      <span class="progress-description"></span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                  <!--ALLOWENCED STUDENTS-->
                  <div class="info-box bg-yellow" v-show="modules.dormitory"
                    @click="getDormitoryFastReport($ml.get('dashboard.fastReportTitleAllowencedStudents'), 2)"
                    style="cursor:pointer;min-height:60px;" :title="$ml.get('dashboard.fastReportView')">
                    <span class="info-box-icon" style="width:40px;height:65px;">
                      <div class="overlay" id="load" :hidden="!isLoadingDormitoryData" style="font-size:30px;">
                        <i class="fa fa-refresh fa-spin"></i>
                      </div>
                      <i v-show="!isLoadingDormitoryData" class="fa fa-calendar-check-o"
                        style="font-size:20px;vertical-align:middle;margin-bottom:20px;"></i>
                    </span>

                    <div class="info-box-content" style="margin-left:10px;text-align:center;">
                      <span class="info-box-text" style="font-size:12px;margin-left:10px;">{{
                        $ml.get('dashboard.allowencedStudentsInDormitory') }}</span>
                      <span class="info-box-number">{{ dormitoryAllowencedStudent }}</span>
                      <div class="progress">
                        <div v-show="dormitoryAllowencedStudent != null" class="progress-bar"
                          :style="'width:' + this.dormitoryAllowencedStudent * 100 / this.dormitoryTotalStudent + '%'">
                        </div>
                      </div>
                      <span class="progress-description"></span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="info-box bg-teal" v-show="modules.licencePlateRecognition"
            @click="getFastReport($ml.get('dashboard.fastReportTitleInsideCars'), 7)" style="cursor:pointer;"
            :title="$ml.get('dashboard.totalCar')">
            <span class="info-box-icon" style="font-size:30px;">
              <div class="overlay" id="load" :hidden="!isLoadingVehicle">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <i v-show="!isLoadingVehicle" class="fa fa-car"></i>
            </span>

            <div class="info-box-content">
              <span class="info-box-text">{{ $ml.get('dashboard.totalCar') }}</span>
              <span class="info-box-number">{{ totalCars }}</span>

              <div class="progress">
                <div v-show="totalCars != null" class="progress-bar"
                  :style="'width:' + this.totalCars * 100 / this.totalEmployees + '%'"></div>
              </div>
              <span class="progress-description"></span>
            </div>
            <!-- /.info-box-content -->
          </div>
          <div class="info-box bg-purple" v-show="modules.licencePlateRecognition"
            @click="getFastReport($ml.get('dashboard.fastReportTitleInsideCars'), 7)" style="cursor:pointer;"
            :title="$ml.get('dashboard.insideCar')">
            <span class="info-box-icon" style="font-size:30px;">
              <div class="overlay" id="load" :hidden="!isLoadingVehicle">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <i v-show="!isLoadingVehicle" class="fa fa-car"></i>
            </span>

            <div class="info-box-content">
              <span class="info-box-text">{{ $ml.get('dashboard.insideCar') }}</span>
              <span class="info-box-number">{{ insideCars }}</span>

              <div class="progress">
                <div v-show="insideCars != null" class="progress-bar"
                  :style="'width:' + this.insideCars * 100 / this.totalCars + '%'"></div>
              </div>
              <span class="progress-description"></span>
            </div>
            <!-- /.info-box-content -->
          </div>
          <div class="info-box bg-maroon" v-show="modules.licencePlateRecognition"
            @click="getFastReport($ml.get('dashboard.fastReportTitleOutsideCars'), 7)" style="cursor:pointer;"
            :title="$ml.get('dashboard.insideCar')">
            <span class="info-box-icon" style="font-size:30px;">
              <div class="overlay" id="load" :hidden="!isLoadingVehicle">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <i v-show="!isLoadingVehicle" class="fa fa-car"></i>
            </span>

            <div class="info-box-content">
              <span class="info-box-text">{{ $ml.get('dashboard.outsideCar') }}</span>
              <span class="info-box-number">{{ outsideCars }}</span>

              <div class="progress">
                <div v-show="outsideCars != null" class="progress-bar"
                  :style="'width:' + this.outsideCars * 100 / this.totalCars + '%'"></div>
              </div>
              <span class="progress-description"></span>
            </div>
            <!-- /.info-box-content -->
          </div>
          <!--BIRTHDAYS-->
          <!--<div v-show="modules.dashboardBirthdays" class="box box-warning">
            <div class="box-header with-border">
              <h3 class="box-title">
                <i class="fa fa-birthday-cake"></i>
                <span>{{$ml.get('dashboard.upcomingBirthdays')}}</span>
              </h3>
            </div>
            <div class="box-body">
              <div
                v-show="birthdayList.length > 0"
                class="table-responsive no-padding"
                style="max-height:200px;owerflow:auto;"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="employee in birthdayList" :key="employee.id" class="rows">
                      <td>
                        <span>{{employee.name}}</span>
                      </td>
                      <td>
                        <span>{{employee.date}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                v-show="birthdayList.length == 0"
              >{{$ml.get('dashboard.upcomingBirthdaysNotFound')}}</div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>-->
        </div>
        <div
          class="col-sm-6 col-md-4">
          <!--MOBILE STATISTIC-->
          <div class="info-box" v-show="modules.mobileApp"
            @click="getFastReport($ml.get('dashboard.fastReportTitleMobileAppUsers'), 10)"
            style="background:#fff;color:#00A0F0;cursor:pointer;" :title="$ml.get('dashboard.fastReportView')">
            <span class="info-box-icon bg-purple" style="font-size:30px;">
              <div class="overlay" id="load" :hidden="!isLoadingData">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <i v-show="!isLoadingData" class="ion ion-person"></i>
            </span>

            <div class="info-box-content">
              <span class="info-box-text">{{ $ml.get('dashboard.registeredMobileAppUser') }}</span>
              <span class="info-box-number">{{ mobileUsers }} / {{ modules.maxMobileUsers }}</span>

              <div class="progress">
                <div v-show="mobileUsers != null" class="progress-bar"
                  :style="'background-color:#00a0f0;width:' + this.mobileUsers * 100 / modules.maxMobileUsers + '%'">
                </div>
              </div>
              <span class="progress-description"></span>
            </div>
            <!-- /.info-box-content -->
          </div>
          <div class="info-box" v-show="modules.mobileApp"
            @click="getFastReport($ml.get('dashboard.fastReportTitleActiveMobileAppUsers'), 12)"
            style="background:#fff;color:#00A0F0;cursor:pointer;" :title="$ml.get('dashboard.fastReportView')">
            <span class="info-box-icon bg-purple" style="font-size:30px;">
              <div class="overlay" id="load" :hidden="!isLoadingData">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <i v-show="!isLoadingData" class="ion ion-ios-checkmark"></i>
            </span>

            <div class="info-box-content">
              <span class="info-box-text">{{ $ml.get('dashboard.activeMobileAppUser') }}</span>
              <span class="info-box-number">{{ activeMobileUsers }} / {{ mobileUsers }}</span>

              <div class="progress">
                <div v-show="activeMobileUsers != null" class="progress-bar"
                  :style="'background-color:#00a0f0;width:' + this.activeMobileUsers * 100 / this.mobileUsers + '%'">
                </div>
              </div>
              <span class="progress-description"></span>
            </div>
            <!-- /.info-box-content -->
          </div>
          <!--PERMISSIONS-->
          <div v-show="modules.allowenceRequests" class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">
                <i class="fa fa-plane"></i>
                <span>{{ $ml.get('dashboard.allowenceRequests') }} : {{ allowenceRequestCount }}</span>
              </h3>
            </div>
            <!-- /.box-header -->
            <div class="box-body">
              <div v-show="allowenceRequestList.length > 0" class="table-responsive no-padding" style="max-height:502px;overflow:auto;">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th v-show="windowWidth >= 1339"></th>
                      <th>{{ $ml.get('dashboard.allowenceHeadNameAndDescription') }}</th>
                      <th>{{ $ml.get('dashboard.allowenceHeadRequestedDates') }}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="request in allowenceRequestList" :key="request.id" class="rows">
                      <td v-show="windowWidth >= 1339">
                        <img style="border-radius:50%;float:left;width:40px;height:40px;"
                          :src="request.image ? request.image : '/src/assets/default-user.png'" />
                      </td>
                      <td>
                        <span>{{ request.name }}</span>
                        <br />
                        <span class="text-muted">{{ request.description | readMore }}</span>
                      </td>
                      <td>
                        <span class="badge label-primary" style="margin-bottom:5px;">{{ request.startDate |
                          toDateFormatGet("gg.aa.yyyy ss:dd") }}</span>
                        <br />
                        <span class="badge label-danger">{{ request.endDate | toDateFormatGet("gg.aa.yyyy ss:dd")}}</span>
                      </td>
                      <td>
                        <button class="btn btn-primary btn-sm" data-toggle="modal" data-target="#modal-allowenceRequest"
                          @click="selectAllowencedRequest(request)">
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="allowenceRequestList.length == 0">{{ $ml.get('dashboard.allowenceRequestNotFound') }}</div>
            </div>
            <!-- /.box-body -->
            <div class="overlay" id="load" :hidden="!isLoadingAllowence">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <!-- /.row-body -->
      </div>
    </section>
    <!-- /.MODAL START-->
    <div class="modal fade" id="modal-device-report">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <button @click="exportToExcelDevices()" type="button" class="btn btn-sm btn-success pull-right">
              <i class="fa fa-share"></i>
              {{ $ml.get('general.exportToExcel') }}
            </button>
            <button @click="exportToPDFDevices()" type="button" class="btn btn-sm btn-danger pull-right">
              <i class="fa fa-share"></i>
              {{ $ml.get('general.exportToPdfOrPrint') }}
            </button>
            <div class="pull-left" style="margin-right:10px;font-size:20px;" :hidden="!isLoadingReport">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <h4 class="modal-title">
              <span>{{ $ml.get('dashboard.deviceStatus') }}</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="input-group" style="margin-bottom: 7px;">
                  <input class="form-control mb-10" type="text" v-model="searchTextDevices"
                  :placeholder="$ml.get('general.search')" />
                  <span class="input-group-btn">
                    <button @click="searchTextDevices = ''" type="button" class="btn btn-danger"><i class="fa fa-times"></i></button>
                      </span>
                </div>
                <div id="printReportDevices" v-show="deviceList != null" class="table-responsive no-padding"
                  :style="windowReportHeightSize">
                  <div class="dep-baslik" style="padding-bottom:10px;padding-top:10px; text-align:center;">
                    <span class="mb-10 text-center">{{ $ml.get('dashboard.deviceStatus') }}<span v-show="lastConnectionTime"> - ({{ lastConnectionTime |
                      toDateFormatGet("gg.aa.yyyy ss:dd") }})</span></span>
                  </div>
                  <table class="table table-hover" id="printExcelDevices">
                    <thead>
                      <tr>
                        <th>{{ $ml.get('dashboard.device') }}</th>
                    <th>{{ $ml.get('dashboard.lastConnection') }}</th>
                    <th>{{ $ml.get('dashboard.status') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="device in filteredDeviceList" :key="device.id" class="rows">
                    <td>
                      <span>{{ device.ip }}</span>
                      <br />
                      <span>{{ device.name }}</span>
                    </td>
                    <td>
                      <span>{{ device.lastConnectionTime }}</span>
                    </td>
                    <td>
                      <span v-if="device.lastConnectionStatus == 'Bağlı'" class="badge label-success">{{
                        device.lastConnectionStatus }}</span>
                      <span v-if="device.lastConnectionStatus == 'Bağlantı Sorunu'" class="badge label-danger">{{
                        device.lastConnectionStatus }}</span>
                    </td>
                  </tr>
                    </tbody>
                  </table>
                </div>
                <div v-show="filteredDeviceList.length == 0" class="callout callout-info">
                  <i class="fa fa-info-circle"></i>
                  {{ $ml.get('dashboard.deviceNotFound') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
    <!-- /.MODAL START-->
    <div class="modal fade" id="modal-fast-report">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <button @click="exportToExcel()" type="button" class="btn btn-sm btn-success pull-right">
              <i class="fa fa-share"></i>
              {{ $ml.get('general.exportToExcel') }}
            </button>
            <button @click="exportToPDF()" type="button" class="btn btn-sm btn-danger pull-right">
              <i class="fa fa-share"></i>
              {{ $ml.get('general.exportToPdfOrPrint') }}
            </button>
            <div class="pull-left" style="margin-right:10px;font-size:20px;" :hidden="!isLoadingReport">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <h4 class="modal-title">
              <span>{{ reportTitle }}</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="input-group" style="margin-bottom: 7px;">
                  <input class="form-control mb-10" type="text" v-model="searchText"
                  :placeholder="$ml.get('general.search')" />
                  <span class="input-group-btn">
                    <button @click="searchText = ''" type="button" class="btn btn-danger"><i class="fa fa-times"></i></button>
                      </span>
                </div>
                <div id="printReport" v-show="fastReportList != null" class="table-responsive no-padding"
                  :style="windowReportHeightSize">
                  <div class="dep-baslik" style="padding-bottom:10px;padding-top:10px; text-align:center;">
                    <span class="mb-10 text-center" v-show="reportTitle != ''">{{ reportTitle }} - ({{ new Date() |
                      toDateFormatGet("gg.aa.yyyy ss:dd") }})</span>
                  </div>
                  <table class="table table-hover" id="printExcel">
                    <thead>
                      <tr>
                        <th v-for="(header, indexHead) in reportHeaderList" :key="indexHead">{{ header }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(report, index) in fastReportList" :key="index">
                        <td>{{ report.sicilNo }}</td>
                        <td>{{ report.name }}</td>
                        <td>{{ report.department }}</td>
                        <td v-if="report.statu != null">{{ report.statu }}</td>
                        <td v-if="report.movement != null">{{ report.movement }}</td>
                        <td v-if="report.title != null">{{ report.title }}</td>
                        <td v-if="report.readerName != null">{{ report.readerName }}</td>
                        <td v-if="report.mobilePhone != null">{{ report.mobilePhone }}</td>
                        <td v-if="report.device != null">{{ report.device }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-show="fastReportList == null || fastReportList == 0" class="callout callout-info">
                  <i class="fa fa-info-circle"></i>
                  {{ $ml.get('dashboard.fastReportNotRecord') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
    <!-- /.MODAL START-->
    <div class="modal fade" id="modal-fast-report-dormitory">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <button @click="exportToExcel2()" type="button" class="btn btn-sm btn-success pull-right">
              <i class="fa fa-share"></i>
              {{ $ml.get('general.exportToExcel') }}
            </button>
            <button @click="exportToPDF2()" type="button" class="btn btn-sm btn-danger pull-right">
              <i class="fa fa-share"></i>
              {{ $ml.get('general.exportToPdfOrPrint') }}
            </button>
            <div class="pull-left" style="margin-right:10px;font-size:20px;" :hidden="!isLoadingReport">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <h4 class="modal-title">
              <span>{{ reportTitle }}</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="input-group" style="margin-bottom: 7px;">
                  <input class="form-control mb-10" type="text" v-model="searchText"
                  :placeholder="$ml.get('general.search')" />
                  <span class="input-group-btn">
                    <button @click="searchText = ''" type="button" class="btn btn-danger"><i class="fa fa-times"></i></button>
                      </span>
                </div>
                <div id="printReportDormitory" v-show="fastReportList != null" class="table-responsive no-padding"
                  :style="windowReportHeightSize">
                  <div class="dep-baslik" style="padding-bottom:10px;padding-top:10px; text-align:center;">
                    <span class="mb-10 text-center" v-show="reportTitle != ''">{{ reportTitle }} - ({{ new Date() |
                      toDateFormatGet("gg.aa.yyyy ss:dd") }})</span>
                  </div>
                  <table class="table table-hover" id="printExcelDormitory">
                    <tbody>
                      <tr v-for="(report, index) in fastReportList" :key="index">
                        <td>{{ report.sicilNo }}</td>
                        <td>{{ report.name }}</td>
                        <td>{{ report.allowence }}</td>
                        <td>{{ report.exitDate }}</td>
                        <td>{{ report.exitPoint }}</td>
                        <td>{{ report.status }}</td>
                        <td>{{ report.isSmsSend }}</td>
                        <td>{{ report.motherName }}</td>
                        <td>{{ report.fatherName }}</td>
                        <td>{{ report.smsPhone }}</td>
                        <td>{{ report.validityDate }}</td>
                        <td>{{ report.areaName }}</td>
                        <td>{{ report.floorName }}</td>
                        <td>{{ report.roomName }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-show="fastReportList == null || fastReportList == 0" class="callout callout-info">
                  <i class="fa fa-info-circle"></i>
                  {{ $ml.get('dashboard.fastReportNotRecord') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
    <!-- /.MODAL START-->
    <div class="modal fade" id="modal-allowenceRequest">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span>{{ $ml.get('dashboard.allowenceRequest') }}</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-4">
                    <img :src="allowenceRequest.image ? allowenceRequest.image : '/src/assets/default-user.png'"
                      style="width:100%;margin-bottom:10px;" />
                  </div>
                  <div class="col-sm-8">
                    <div class="form-group">
                      <label>Kişi</label>
                      <label class="form-control" style="height:auto;">
                        <span v-show="allowenceRequest.sicilNo != ''">{{ allowenceRequest.sicilNo }} - </span>
                        {{ allowenceRequest.name }}
                      </label>
                    </div>
                    <div class="form-group">
                      <label>Ünvan</label>
                      <label class="form-control" style="height:auto;">{{ allowenceRequest.title }}</label>
                    </div>
                    <div class="form-group">
                      <label>Departman</label>
                      <label class="form-control" style="height:auto;">{{ allowenceRequest.department }}</label>
                    </div>
                    <div class="form-group">
                      <label>İzinin Talep Edildiği Tarih</label>
                      <label class="form-control">{{ allowenceRequest.createdDate | toDateFormatGet("gg.aa.yyyy ss:dd")}}</label>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>Başlangıç Tarihi</label>
                          <label class="form-control">{{ allowenceRequest.startDate | toDateFormatGet("gg.aa.yyyy ss:dd")}}</label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>Bitiş Tarihi</label>
                          <label class="form-control">{{ allowenceRequest.endDate | toDateFormatGet("gg.aa.yyyy ss:dd")}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>İzin Talebi Açıklaması</label>
                      <label class="form-control" style="height:auto;">{{ allowenceRequest.description }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary pull-left" data-dismiss="modal">{{ $ml.get('general.close')
              }}</button>
            <button class="btn btn-danger" @click="rejectAllowenceRequestModal()">
              <i class="fa fa-remove"></i> Reddet
            </button>
            <button class="btn btn-success" @click="successAllowenceRequestModal()">
              <i class="fa fa-check"></i> Onayla (İzine Dönüştür)
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
    <!-- /.MODAL START-->
    <div class="modal modal-success fade" id="modal-allowenceRequest-success">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span>{{ $ml.get('dashboard.allowenceRequest') }} Onayı</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 text-center">
                <label>
                  <span v-show="allowenceRequest.sicilNo != ''">({{ allowenceRequest.sicilNo }})</span>
                  {{ allowenceRequest.name }}
                  <br />
                  {{ allowenceRequest.title }}
                  <br />
                  {{ allowenceRequest.department }}
                  <br />kişisi için izin oluştur
                </label>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <div class="table-responsive" style="height:350px; overflow:auto;">
                  <h4>{{ $ml.get('employees.validDays') }}</h4>
                  <table class="table table-hover" style="font-size:15px;">
                    <tbody>
                      <tr v-for="day in dayList" :key="day.value">
                        <td class="checkbox">
                          <label style="margin-left:30px">
                            <input type="checkbox" name="check" :checked="day.check"
                              @change="day.check == true ? day.check = false : day.check = true" />
                            {{ day.name }}
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="form-group col-sm-12">
                  <label>{{ $ml.get('employees.typeAllowence') }}</label>
                  <select @change="changeAllowenceType($event)" class="form-control">
                    <option :selected="allowence.allowenceType == 0" value="0">{{ $ml.get('employees.dailyAllowence')
                      }}
                    </option>
                    <option :selected="allowence.allowenceType == 1" value="1">
                      {{ $ml.get('employees.hourlyAllowence') }}</option>
                  </select>
                </div>
                <div class="form-group col-sm-12">
                  <label>{{ $ml.get('employees.startTimeAllowence') }}</label>
                  <input v-model="allowence.startDate" @change="changeAllowenceStartTime()" type="datetime-local"
                    class="form-control" />
                </div>
                <div class="form-group col-sm-12">
                  <label>{{ $ml.get('employees.endTimeAllowence') }}</label>
                  <input v-model="allowence.endDate" type="datetime-local" class="form-control" />
                </div>
                <div class="form-group col-sm-12">
                  <label>{{ $ml.get('employees.allowence') }}</label>
                  <select @change="changeAllowence($event)" class="form-control">
                    <option v-for="allowence3 in allowenceList" :key="allowence3.id"
                      :selected="allowence3.id == allowence.allowenceId" :value="allowence3.id">
                      {{ allowence3.shortCode }} - {{ allowence3.name }}</option>
                  </select>
                </div>
                <div v-show="allowence.allowenceType == 1" class="form-group col-sm-6">
                  <label>{{ $ml.get('employees.totalTimeAllowence') }}</label>
                  <input type="time" class="form-control" v-model="allowence.allowenceTime" />
                </div>
                <div v-show="allowence.allowenceType == 1" class="form-group col-sm-6">
                  <label>{{ $ml.get('employees.missingHourAllowence') }}</label>
                  <input type="time" class="form-control" v-model="allowence.missingTime"
                    @change="changeEqualMissingTime()" />
                </div>
                <div v-show="allowence.allowenceType == 1" class="form-group col-sm-12">
                  <label>{{ $ml.get('employees.isEqualTheMissingTime') }}</label>
                  <span class="form-control checkbox">
                    <label style="margin-left:20px;">
                      <input :checked="allowence.equalTheMissingTime" @change="changeCheckEqualMissingTime()"
                        type="checkbox" />
                      {{ $ml.get('employees.equalTheMissingTime') }}
                    </label>
                  </span>
                </div>
                <div v-show="allowence.allowenceType == 0" class="form-group col-sm-12">
                  <label>{{ $ml.get('employees.doesApplyHolidays') }}</label>
                  <span class="form-control checkbox">
                    <label style="margin-left:20px;">
                      <input :checked="allowence.holidayPass"
                        @change="allowence.holidayPass == true ? allowence.holidayPass = false : allowence.holidayPass = true"
                        type="checkbox" />
                      {{ $ml.get('employees.applyHolidays') }}
                    </label>
                  </span>
                </div>
                <div class="form-group col-sm-12">
                  <label>{{ $ml.get('employees.descriptionAllowence') }}</label>
                  <textArea v-model="allowence.description" type="text" class="form-control"></textArea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
            <button class="btn btn-success" @click="successAllowenceRequest()">
              <i class="fa fa-check"></i> Kaydet
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
    <!-- /.MODAL START-->
    <div class="modal modal-danger fade" id="modal-allowenceRequest-reject">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span>{{ $ml.get('dashboard.allowenceRequest') }} Onayı</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 text-center">
                <label>
                  <span v-show="allowenceRequest.sicilNo != ''">({{ allowenceRequest.sicilNo }})</span>
                  {{ allowenceRequest.name }}
                  <br />
                  {{ allowenceRequest.title }}
                  <br />
                  {{ allowenceRequest.department }}
                  <br />kişisi için izin talebini reddet
                </label>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12">
                <label>Red Açıklaması</label>
                <textArea v-model="allowenceRequestDescription" type="text" class="form-control"></textArea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
            <button class="btn btn-success" @click="rejectAllowenceRequest()">
              <i class="fa fa-check"></i> Kaydet
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
export default {
  data() {
    return {
      isLoading: false,
      isLoadingFoodData: false,
      isLoadingData: false,
      isLoadingVehicle: false,
      isLoadingVisitor: false,
      isLoadingDormitoryData: false,
      isLoadingReport: false,
      isLoadingAllowence: false,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      searchText: "",
      searchTextDevices: "",
      totalFoodCount: 0,
      startWorkEmployees: "0",
      lateComers: "0",
      discontinuity: "0",
      totalEmployees: "0",
      lastConnectionTime: null,
      insides: "0",
      outsides: "0",
      insideVisitors: "0",
      allowencedEmployees: "0",
      mobileUsers: "0",
      activeMobileUsers: "0",
      insideCars: "0",
      outsideCars: "0",
      totalCars: "0",
      dormitoryTotalStudent: "0",
      dormitoryInsideStudent: "0",
      dormitoryOutsideStudent: "0",
      dormitoryAllowencedStudent: "0",
      devices: [],
      connectedDevice: 0,
      disconnectedDevice: 0,
      otherDeviceStatus: 0,
      departments: [],
      birthDays: [],
      allowences: [],
      allowenceRequests: [],
      allowenceRequestDescription: "",
      allowenceRequest: {
        id: null,
        empID: null,
        name: "",
        description: "",
        startDate: null,
        endDate: null,
        image: null,
        sicilNo: "",
        title: "",
        department: "",
        createdDate: null
      },
      allowence: {
        id: null,
        searchStartDate: null,
        searchEndDate: null,
        startDate: null,
        endDate: null,
        allowenceType: 0,
        description: "",
        allowenceId: null,
        holidayPass: false,
        allowenceTime: "00:00",
        missingTime: "00:00",
        equalTheMissingTime: true
      },
      days: [
        { value: 1, name: this.$ml.get("general.monday"), check: true },
        { value: 2, name: this.$ml.get("general.tuesday"), check: true },
        { value: 3, name: this.$ml.get("general.wednesday"), check: true },
        { value: 4, name: this.$ml.get("general.thursday"), check: true },
        { value: 5, name: this.$ml.get("general.friday"), check: true },
        { value: 6, name: this.$ml.get("general.saturday"), check: true },
        { value: 7, name: this.$ml.get("general.sunday"), check: true }
      ],
      reportHeaders: [],
      reportDatas: [],
      reportTitle: "",
      authMap: {
        canliIzleme: 2,
        kisiler: 2,
        gecisYetkileri: 2,
        raporlar: 2,
        ayarlar: 2,
        tanimlamalar: 2,
        ziyaretciTakip: 2,
        yemekhane: 2,
        creditSale: 2,
        dashboard: 2,
        shiftYonetimi: 2,
        puantajYonetimi: 2,
        shiftYetkileri: {
          canPlan: true,
          canConfirmShift: true,
          canConfirmAllowence: true,
          canPlanAllowence: true,
          canSeeRealMovements: false,
          sendMailWhenUnconfirmedShifts: false,
          sendWarningMailOnSecondDay: false
        }
      },
      chart: null,
      chart2: null,
      chart3: null,
      infoEmployees: {
        series: [],
        labels: [],
        dataLabels: {
          enabled: true
        },
        colors: [
          "#00A65A",
          "#DD4B39",
          "#F39C12",
          "#3C8DBC",
          "#364b98",
          "#d63384",
          "#fd7e14",
          "#6610f2",
          "#20c997",
          "#0dcaf0",
          "#6c757d",
          "#6f42c1"
        ],
        chart: {
          fontFamily: "Nunito",
          type: "donut",
          width: "100%",
          height: "350px"
        },
        legend: {
          show: true,
          position: "bottom"
        },
        plotOptions: {
          pie: {
            donut: {
              size: "30%"
            }
          }
        }
      },
      infoStudents: {
        series: [],
        labels: [],
        dataLabels: {
          enabled: true
        },
        colors: [
          "#00A65A",
          "#DD4B39",
          "#F39C12",
          "#3C8DBC",
          "#364b98",
          "#d63384",
          "#fd7e14",
          "#6610f2",
          "#20c997",
          "#0dcaf0",
          "#6c757d",
          "#6f42c1"
        ],
        chart: {
          fontFamily: "Nunito",
          type: "donut",
          width: "100%",
          height: "350px"
        },
        legend: {
          show: true,
          position: "bottom"
        },
        plotOptions: {
          pie: {
            donut: {
              size: "30%"
            }
          }
        }
      },
      infoDevices: {
        series: [],
        labels: [],
        dataLabels: {
          enabled: true
        },
        colors: [
          "#00A65A",
          "#DD4B39",
          "#F39C12",
          "#3C8DBC",
          "#364b98",
          "#d63384",
          "#fd7e14",
          "#6610f2",
          "#20c997",
          "#0dcaf0",
          "#6c757d",
          "#6f42c1"
        ],
        chart: {
          fontFamily: "Nunito",
          type: "donut",
          width: "100%",
          height: "350px"
        },
        legend: {
          show: true,
          position: "bottom"
        },
        plotOptions: {
          pie: {
            donut: {
              size: "30%"
            }
          }
        }
      },
    };
  },
  filters: {
    toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    readMore(str) {
      if (str.length > 40) {
        return str.slice(0, 40) + "...";
      } else {
        return str;
      }
    }
  },
  computed: {
    modules() {
      return this.$store.getters.getModules;
    },
    fastReportList() {
      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.reportDatas.filter(item => {
          return search
            .split(" ")
            .every(v => this.turkishToUpper(item.name).includes(v));
        });
      } else {
        return this.reportDatas;
      }
    },
    reportHeaderList() {
      return this.reportHeaders;
    },
    departmentList() {
      return this.departments;
    },
    deviceList() {
      return this.devices;
    },
    filteredDeviceList(){
      var search = this.turkishToUpper(this.searchTextDevices);
      if (search) {
        return this.devices.filter(item => {
          return search
            .split(" ")
            .every(v => this.turkishToUpper(item.name).includes(v) || (item.ip).includes(v));
        });
      } else {
        return this.devices;
      }
    },
    birthdayList() {
      return this.birthDays;
    },
    dayList() {
      return this.days;
    },
    allowenceList() {
      return this.allowences;
    },
    allowenceRequestList() {
      return this.allowenceRequests;
    },
    allowenceRequestCount() {
      if (this.allowenceRequests[0]) {
        return this.allowenceRequests.length;
      } else {
        return 0;
      }
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 180;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowReportHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 180;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    },
    windowWidth(newWidth, oldWidth) {
      if (newWidth < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
    },
    turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    exportToPDF2() {
      this.$htmlToPaper("printReportDormitory");
    },
    exportToPDFDevices() {
      this.$htmlToPaper("printReportDevices");
    },
    exportToExcel() {
      var tarih = new Date();
      var filename = this.reportTitle + " - " + tarih.toLocaleString();
      $("#printExcel").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    exportToExcel2() {
      var tarih = new Date();
      var filename = this.reportTitle + " - " + tarih.toLocaleString();
      $("#printExcelDormitory").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    exportToExcelDevices() {
      var tarih = new Date();
      var filename = this.$ml.get('dashboard.deviceStatus') + " - " + tarih.toLocaleString();
      $("#printExcelDevices").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    async doldur() {
      var elem = document.getElementById("infoEmployees");
      this.chart = await new ApexCharts(elem, this.infoEmployees);
      this.chart.render();
    },
    async doldurDormitory() {
      var elem2 = document.getElementById("infoStudents");
      this.chart2 = await new ApexCharts(elem2, this.infoStudents);
      this.chart2.render();
    },
    async chartDevices() {
      var elem3 = document.getElementById("infoDevices");
      this.chart3 = await new ApexCharts(elem3, this.infoDevices);
      this.chart3.render();
    },
    authControl(data) {
      if (data != null) {
        if (data == 2) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    changeAllowenceType(event) {
      this.allowence.allowenceType = event.target.value;
    },
    changeAllowence(event) {
      this.allowence.allowenceId = event.target.value;
    },
    changeEqualMissingTime() {
      if (this.allowence.equalTheMissingTime == true) {
        this.allowence.allowenceTime = this.allowence.missingTime;
      }
    },
    changeCheckEqualMissingTime() {
      if (this.allowence.equalTheMissingTime == true) {
        this.allowence.equalTheMissingTime = false;
        this.allowence.allowenceTime = "00:00";
      } else {
        this.allowence.equalTheMissingTime = true;
        this.allowence.allowenceTime = this.allowence.missingTime;
      }
    },
    async changeAllowenceStartTime() {
      if (this.allowence.allowenceType == 1) {
        let ed = this.allowence.endDate.split("T");
        let sd = this.allowence.startDate.split("T");
        this.allowence.endDate = sd[0] + "T" + ed[1];
        let startDate = sd[0] + "T" + sd[1];
        if (
          startDate != null &&
          sd[0] != null &&
          sd[1] != null &&
          startDate > "1900-01-01T00:00"
        ) {
          let id = this.allowenceRequest.empID;
          const response = await this.$axios.post(
            "/EmployeeDetails/GetMissingHour",
            {
              empID: id,
              date: startDate
            }
          );
          if (response.status == 200) {
            let mT = response.data;
            let mTT = mT.split("T");
            this.allowence.missingTime = mTT[1];
            if (this.allowence.equalTheMissingTime == true) {
              this.allowence.allowenceTime = mTT[1];
            }
          } else if (response.status == 201) {
            this.allowence.missingTime = "00:00";
            this.allowence.allowenceTime = "00:00";
            alertify.warning(this.$ml.get("alerts.selectedDayNotMissingHour"));
          }
        }
      }
    },
    selectedDays() {
      let selectedDays = [];
      let aList = this.days;
      aList.forEach(doc => {
        if (doc.check == true) {
          selectedDays.push(doc.value);
        }
      });
      return selectedDays;
    },
    newAllowence() {
      this.isNewAllowence = true;
      this.allowence.id = null;
      if (this.allowenceList[0]) {
        this.allowence.allowenceId = this.allowenceList[0].id;
      }
      this.allowence.description = "";
      this.allowence.allowenceType = 0;
      this.allowence.holidayPass = false;
      this.allowence.allowenceTime = "00:00";
      this.allowence.missingTime = "00:00";
      this.allowence.equalTheMissingTime = true;
    },
    selectAllowencedRequest(request) {
      this.allowenceRequest.id = request.id;
      this.allowenceRequest.empID = request.empID;
      this.allowenceRequest.sicilNo = request.sicilNo;
      this.allowenceRequest.department = request.department;
      this.allowenceRequest.title = request.title;
      this.allowenceRequest.createdDate = request.createdDate;
      this.allowenceRequest.name = request.name;
      this.allowenceRequest.description = request.description;
      this.allowenceRequest.startDate = request.startDate;
      this.allowenceRequest.endDate = request.endDate;
      this.allowenceRequest.image = request.image;
    },
    rejectAllowenceRequestModal() {
      $("#modal-allowenceRequest").modal("hide");
      $("#modal-allowenceRequest-reject").modal("show");
    },
    async successAllowenceRequestModal() {
      await this.newAllowence();
      $("#modal-allowenceRequest").modal("hide");
      this.allowence.startDate = this.allowenceRequest.startDate;
      this.allowence.endDate = this.allowenceRequest.endDate;
      $("#modal-allowenceRequest-success").modal("show");
    },
    async successAllowenceRequest() {
      if ((this.allowence.startDate == "") | this.allowence.endDate) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if (!this.allowence.allowenceId) {
        alertify.warning(this.$ml.get("alerts.pleaseSelect"));
        return;
      }
      try {
        this.isLoadingAllowence = true;
        let days = await this.selectedDays();
        let empIds = [this.allowenceRequest.empID];
        let allowence2 = this.allowence;
        this.allowenceRequestDescription = this.allowence.description;
        const response = await this.$axios.post(
          "/BatchOperations/BatchAllowence",
          {
            empIds: empIds,
            days: days,
            allowenceId: allowence2.allowenceId,
            description: allowence2.description,
            holidayPass: allowence2.holidayPass,
            startDate: allowence2.startDate,
            endDate: allowence2.endDate,
            allowenceType: allowence2.allowenceType,
            allowenceTime: allowence2.allowenceTime,
            equalTheMissingTime: allowence2.equalTheMissingTime,
            missingTime: allowence2.missingTime
          }
        );
        if (response.status == 200) {
          const response2 = await this.$axios.post(
            "/AllowenceRequest?id=" +
            this.allowenceRequest.id +
            "&status=1&description=" +
            this.allowenceRequestDescription
          );
          if (response2.status == 200) {
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
            $("#modal-allowenceRequest-success").modal("hide");
            await this.getAllowenceRequests();
          } else {
            alertify.error(response.message);
          }
        } else {
          alertify.error(response.message);
        }
        this.isLoadingAllowence = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingAllowence = false;
      }
    },
    async rejectAllowenceRequest() {
      try {
        const response2 = await this.$axios.post(
          "/AllowenceRequest?id=" +
          this.allowenceRequest.id +
          "&status=2&description=" +
          this.allowenceRequestDescription
        );
        if (response2.status == 200) {
          alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          $("#modal-allowenceRequest-reject").modal("hide");
          await this.getAllowenceRequests();
        } else {
          alertify.error(response.message);
        }
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingAllowence = false;
      }
    },
    openDeviceReport(){
      $("#modal-device-report").modal("show");
    },
    async getFastReport(title, number) {
      if (this.authControl(this.authMap.raporlar)) {
        $("#modal-fast-report").modal("show");
        this.reportTitle = title;
        try {
          this.isLoadingReport = true;
          this.searchText = "";
          this.reportDatas = [];
          const response = await this.$axios
            .get("/Dashboard/DailyInfo/" + number)
            .then(response => {
              this.reportDatas = response.data;
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingReport = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingReport = false;
                  return;
                }
              }
            });
          this.reportHeaders = [];
          if (number == 0) {
            this.startWorkEmployees = this.reportDatas.length;
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.registrationNumber")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.name")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.department")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.status")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.datetime")
            );
          } else if (number == 1) {
            this.discontinuity = this.reportDatas.length;
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.registrationNumber")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.name")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.department")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.status")
            );
          } else if (number == 2) {
            this.totalEmployees = this.reportDatas.length;
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.registrationNumber")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.name")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.department")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.status")
            );
          } else if (number == 3) {
            this.insides = this.reportDatas.length;
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.registrationNumber")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.name")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.department")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.status")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.datetime")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.readerName")
            );
          } else if (number == 4) {
            this.outsides = this.reportDatas.length;
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.registrationNumber")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.name")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.department")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.status")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.datetime")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.readerName")
            );
          } else if (number == 5) {
            this.allowencedEmployees = this.reportDatas.length;
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.registrationNumber")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.name")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.department")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.status")
            );
          } else if (number == 6) {
            this.insideVisitors = this.reportDatas.length;
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.citizenshipNumber")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.visitorName")
            );
            this.reportHeaders.push("");
            this.reportHeaders.push("");
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.entryTime")
            );
          } else if (number == 10) {
            this.mobileUsers = this.reportDatas.length;
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.registrationNumber")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.name")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.department")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.status")
            );
          } else if (number == 11) {
            this.lateComers = this.reportDatas.length;
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.registrationNumber")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.name")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.department")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.status")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.datetime")
            );
          } else if (number == 12) {
            this.activeMobileUsers = this.reportDatas.length;
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.registrationNumber")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.name")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.department")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.title")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.mobilePhone")
            );
            this.reportHeaders.push(
              this.$ml.get("dashboard.fastReportHeaderItems.device")
            );
          }
          this.isLoadingReport = false;
        } catch (error) {
          console.error(error);
          alertify.error("Servis Hatası :" + error.message);
          this.isLoadingReport = false;
        }
      }
    },
    async getDormitoryFastReport(title, number) {
      if (this.authControl(this.authMap.raporlar)) {
        $("#modal-fast-report-dormitory").modal("show");
        this.reportTitle = title;
        try {
          this.isLoadingReport = true;
          this.searchText = "";
          this.reportDatas = [];
          const response = await this.$axios
            .get("/Dormitory/DailyInfo/" + number)
            .then(response => {
              this.reportDatas = response.data;
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingReport = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingReport = false;
                  return;
                }
              }
            });
          if (number == 0) {
            this.dormitoryInsideStudent = this.reportDatas.length;
          } else if (number == 1) {
            this.dormitoryOutsideStudent = this.reportDatas.length;
          } else if (number == 2) {
            this.dormitoryAllowencedStudent = this.reportDatas.length;
          } else if (number == 3) {
            this.dormitoryTotalStudent = this.reportDatas.length;
          }
          this.isLoadingReport = false;
        } catch (error) {
          console.error(error);
          alertify.error("Servis Hatası :" + error.message);
          this.isLoadingReport = false;
        }
      }
    },
    async getDevices() {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .get("/Terminal")
          .then(response => {
            this.devices = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
          var connected = this.deviceList.filter(device => {
            return device.lastConnectionStatus == 'Bağlı';
          });
          var disconnected = this.deviceList.filter(device => {
            return device.lastConnectionStatus == 'Bağlantı Sorunu';
          });
          var other = this.deviceList.length - connected.length - disconnected.length;
          this.connectedDevice = connected.length;
          this.disconnectedDevice = disconnected.length;
          this.otherDeviceStatus = other;

          this.infoDevices.labels.push("Bağlı");
        this.infoDevices.labels.push("Bağlantı Sorunu");
        this.infoDevices.labels.push("Bilinmeyen");
        this.infoDevices.series.push(this.connectedDevice);
        this.infoDevices.series.push(this.disconnectedDevice);
        this.infoDevices.series.push(this.otherDeviceStatus);
        await this.chartDevices();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getDepartments() {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .get("/Dashboard/Departments")
          .then(response => {
            this.departments = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getDatas() {
      try {
        this.isLoadingData = true;
        var startWorkEmployees2 = "0";
        var lateComers2 = "0";
        var discontinuity2 = "0";
        var totalEmployees2 = "0";
        var lastConnectionTime2 = null;
        var insides2 = "0";
        var outsides2 = "0";
        var allowencedEmployees2 = "0";
        var mobileUsers2 = "0";
        var activeMobileUsers2 = "0";
        var birthDays2 = [];
        const response = await this.$axios
          .get("/Dashboard")
          .then(response => {
            if (response.status == 200) {
              startWorkEmployees2 = response.data.startWorkEmployees;
              lateComers2 = response.data.lateComers;
              discontinuity2 = response.data.discontinuity;
              totalEmployees2 = response.data.totalEmployees;
              lastConnectionTime2 = response.data.lastConnectionTime;
              insides2 = response.data.insides;
              outsides2 = response.data.outsides;
              allowencedEmployees2 = response.data.allowencedEmployees;
              birthDays2 = response.data.birthDays;
              mobileUsers2 = response.data.mobileUsers;
              activeMobileUsers2 = response.data.activeMobileUsers;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingData = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingData = false;
                return;
              }
            }
          });
        this.startWorkEmployees = startWorkEmployees2;
        this.lateComers = lateComers2;
        this.discontinuity = discontinuity2;
        this.totalEmployees = totalEmployees2;
        this.lastConnectionTime = lastConnectionTime2;
        this.insides = insides2;
        this.outsides = outsides2;
        this.allowencedEmployees = allowencedEmployees2;
        this.birthDays = birthDays2;
        this.mobileUsers = mobileUsers2;
        this.activeMobileUsers = activeMobileUsers2;
        this.infoEmployees.labels.push(this.$ml.get("dashboard.insides"));
        this.infoEmployees.labels.push(this.$ml.get("dashboard.outsides"));
        if (this.modules.payroll) {
          this.infoEmployees.labels.push(
            this.$ml.get("dashboard.allowenceEmployees")
          );
        }
        this.infoEmployees.series.push(insides2);
        this.infoEmployees.series.push(outsides2);
        if (this.modules.payroll) {
          this.infoEmployees.series.push(allowencedEmployees2);
        }
        await this.doldur();
        this.isLoadingData = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
        this.isLoadingData = false;
      }
    },
    async getVisitorDatas() {
      try {
        this.isLoadingVisitor = true;
        var insideVisitors2 = "0";
        const response = await this.$axios
          .get("/Dashboard/Visitors")
          .then(response => {
            if (response.status == 200) {
              insideVisitors2 = response.data.insideVisitors;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingVisitor = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingVisitor = false;
                return;
              }
            }
          });
        this.insideVisitors = insideVisitors2;
        this.isLoadingVisitor = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
        this.isLoadingVisitor = false;
      }
    },
    async getVehicleData() {
      try {
        this.isLoadingVehicle = true;
        var insideCars2 = "0";
        var outsideCars2 = "0";
        var totalCars2 = "0";
        const response = await this.$axios
          .get("/Dashboard/Vehicles")
          .then(response => {
            if (response.status == 200) {
              insideCars2 = response.data.insideCars;
              outsideCars2 = response.data.outsideCars;
              totalCars2 = response.data.totalCars;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingVehicle = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingVehicle = false;
                return;
              }
            }
          });
        this.insideCars = insideCars2;
        this.outsideCars = outsideCars2;
        this.totalCars = totalCars2;
        this.isLoadingVehicle = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
        this.isLoadingVehicle = false;
      }
    },
    async getDormitoryDatas() {
      try {
        this.isLoadingDormitoryData = true;
        var dormitoryTotalStudent2 = "0";
        var dormitoryInsideStudent2 = "0";
        var dormitoryOutsideStudent2 = "0";
        var dormitoryAllowencedStudent2 = "0";
        const response = await this.$axios
          .get("/Dormitory")
          .then(response => {
            if (response.status == 200) {
              dormitoryTotalStudent2 = response.data.total;
              dormitoryInsideStudent2 = response.data.insides;
              dormitoryOutsideStudent2 = response.data.outsides;
              dormitoryAllowencedStudent2 = response.data.allowenced;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDormitoryData = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDormitoryData = false;
                return;
              }
            }
          });
        this.dormitoryTotalStudent = dormitoryTotalStudent2;
        this.dormitoryInsideStudent = dormitoryInsideStudent2;
        this.dormitoryOutsideStudent = dormitoryOutsideStudent2;
        this.dormitoryAllowencedStudent = dormitoryAllowencedStudent2;
        this.infoStudents.labels.push(
          this.$ml.get("dashboard.insideStudentsInDormitory")
        );
        this.infoStudents.labels.push(
          this.$ml.get("dashboard.outsideStudentsInDormitory")
        );
        this.infoStudents.labels.push(
          this.$ml.get("dashboard.allowencedStudentsInDormitory")
        );
        this.infoStudents.series.push(dormitoryInsideStudent2);
        this.infoStudents.series.push(dormitoryOutsideStudent2);
        this.infoStudents.series.push(dormitoryAllowencedStudent2);
        await this.doldurDormitory();
        this.isLoadingDormitoryData = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
        this.isLoadingDormitoryData = false;
      }
    },
    async getTotalFoodCount() {
      try {
        this.isLoadingFoodData = true;
        await this.$axios
          .get("/FoodMenu/GetFoodCount")
          .then(response => {
            if (response.status == 200) {
              this.totalFoodCount = response.data;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingFoodData = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingFoodData = false;
                return;
              }
            }
          });
        this.isLoadingFoodData = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
        this.isLoadingFoodData = false;
      }
    },
    async getAllowenceRequests() {
      try {
        this.isLoadingAllowence = true;
        var allowenceRequests = [];
        await this.$axios
          .get("/AllowenceRequest")
          .then(response => {
            if (response.status == 200) {
              allowenceRequests = response.data;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingAllowence = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingAllowence = false;
                return;
              }
            }
          });
        this.allowenceRequests = allowenceRequests;
        this.isLoadingAllowence = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
        this.isLoadingAllowence = false;
      }
    },
    async getAuthority() {
      try {
        this.isLoading = true;
        var authMap = {};
        const response = await this.$axios
          .get("/User/GetAuthMap")
          .then(response => {
            if (response.status == 200) {
              authMap.canliIzleme = response.data.canliIzleme;
              authMap.kisiler = response.data.kisiler;
              authMap.gecisYetkileri = response.data.gecisYetkileri;
              authMap.raporlar = response.data.raporlar;
              authMap.ayarlar = response.data.ayarlar;
              authMap.tanimlamalar = response.data.tanimlamalar;
              authMap.ziyaretciTakip = response.data.ziyaretciTakip;
              authMap.yemekhane = response.data.yemekhane;
              authMap.dashboard = response.data.dashboard;
              authMap.creditSale = response.data.creditSale;
              authMap.shiftYonetimi = response.data.shiftYonetimi;
              authMap.puantajYonetimi = response.data.puantajYonetimi;
              authMap.shiftYetkileri = response.data.shiftYetkileri;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.authMap = authMap;
        await this.$store.commit("setAuthority", authMap);
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata : " + error.message);
        this.isLoading = false;
      }
    },
    async getAllowences() {
      try {
        const allowences = [];
        const response = await this.$axios
          .get("/Allowences")
          .then(response => {
            response.data.forEach(doc => {
              allowences.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                monthlyPayrollId: doc.monthlyPayrollId,
                dailyPayrollId: doc.dailyPayrollId,
                dayTime: doc.dayTime,
                colorCode: doc.colorCode
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.allowences = allowences;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    }
  },
  beforeDestroy() {
    try {
      window.removeEventListener("resize", this.onResize);
      this.chart.destroy();
      this.chart2.destroy();
      this.chart3.destroy();
    } catch (e) { }
  },
  async created() {
    let language = localStorage.getItem("lang");
    if (language) {
      this.$ml.change(language);
    }
    await this.getAuthority();
    if (this.authMap.dashboard == 2) {
      if (this.authMap.creditSale != 2 && this.modules.retailSale) {
        this.$router.replace("/retail-sale");
      } else if (this.authMap.ziyaretciTakip != 2 && this.modules.visitor) {
        this.$router.replace("/visitors");
      } else {
        this.$router.replace("/real-time-monitor");
      }
      return;
    } else {
      this.getTotalFoodCount();
      this.getDevices();
      this.getDatas();
      this.getDepartments();
      if (this.modules.licencePlateRecognition) {
        this.getVehicleData();
      }
      if (this.modules.dormitory) {
        this.getDormitoryDatas();
      }
      if (this.modules.visitor) {
        this.getVisitorDatas();
      }
      if (this.modules.allowenceRequests) {
        this.getAllowences();
        this.getAllowenceRequests();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/dashboard/Dashboard.vue